// extracted by mini-css-extract-plugin
export default {"supplierManagement":"SupplierManagement_supplierManagement__TcisE","supplierForm":"SupplierManagement_supplierForm__NSCwt","supplierTable":"SupplierManagement_supplierTable__08v-a"};